/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import {
  Link,
  useLocation
} from "react-router-dom";
//////
import "./assets/bulma.css";
import "./assets/tailwind.min.css";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}


export default function PopupBalanceLock(props: any) {
  let query = useQuery();


  return <div className="">
    <h1 className="bm-title bm-is-primary bm-is-4 mt-4">Lock Balance</h1>
  </div>
}
